import NavigationService from "services/navigation";
import { Flex, Layout, Spin } from "antd";
import React, { Component } from "react";
import { Outlet } from "react-router-dom";
import TarotsService from "services/tarots";
import PremiumsService from "services/premiums";
import UserService from "services/user";
import NotificationService from "services/notification";
import TagsService from "services/tags";
import withRouter from "hocs/withRouter";
import { SafeArea } from "antd-mobile";
import { TabBar } from "antd-mobile";
import {
  CommentOutlined,
  InboxOutlined,
  UserOutlined,
} from "@ant-design/icons";
import store from "data/store";
import { Observer, observer } from "mobx-react";
import CrashlyticsService from "services/crashlytics";

class HomePage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
    };
  }

  tabs = [
    {
      key: "chats",
      label: "Chats",
      icon: <CommentOutlined />,
      badge: <Observer>{() => store.chats.onlyOnline.length}</Observer>,
    },
    {
      key: "history",
      label: "History",
      icon: <InboxOutlined />,
    },
    {
      key: "profile",
      label: "Profile",
      icon: <UserOutlined />,
    },
  ];

  handleTabChange = (tab) => {
    NavigationService.navigate("/" + tab);
  };

  get currentTab() {
    return window.location.pathname.split("/")[1];
  }

  async componentDidMount() {
    try {
      await UserService.init();
      NotificationService.init();
      TarotsService.init();
      PremiumsService.init();
      TagsService.init();
      CrashlyticsService.identify(store.user.id);
      this.setState({ loading: false });
    } catch (error) {
      console.log("error", error);
    }
  }

  render() {
    if (this.state.loading) return <Spin size="large" fullscreen />;

    return (
      <Layout>
        <Layout.Content
          style={{
            height: "-webkit-fill-available",
            height: "100svh",
            width: "100vw",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <SafeArea position="top" />
          <Flex style={{ flexGrow: 1, overflow: "scroll" }}>
            <Outlet />
          </Flex>
          <Observer>
            {() => (
              <TabBar
                activeKey={this.currentTab}
                onChange={this.handleTabChange}
              >
                {this.tabs.map((tab) => (
                  <TabBar.Item
                    key={tab.key}
                    title={tab.label}
                    icon={tab.icon}
                    badge={tab.badge}
                  />
                ))}
              </TabBar>
            )}
          </Observer>
          <SafeArea position="bottom" />
        </Layout.Content>
      </Layout>
    );
  }
}

export default withRouter(observer(HomePage));
